import React from 'react';
import { ClipboardIcon } from '@heroicons/react/24/outline';
import { Button } from 'components/shadcn/ui/button';
import { useToast } from 'components/shadcn/hooks/use-toast';

const HGClickToCopy = (props) => {
    const { toast } = useToast();
    return (
        <div className="flex items-center gap-1" style={props?.sx}>
            {props.children}
            <Button
                variant="outline"
                size="icon"
                className="h-7 w-7 bg-card hover:bg-muted dark:border-slate-800"
                onClick={(e) => {
                    e.stopPropagation();
                    navigator.clipboard.writeText(props?.content);
                    toast({ title: 'Copied to clipboard' });
                }}
            >
                <ClipboardIcon className="h-4 w-4" />
            </Button>
        </div>
    );
};

export default HGClickToCopy;
